<template>
  <div class="text-gray-600 right-of-withdrawal-component">
    <i18n class="right-of-withdrawal-component-subject-title ota-p18 text-center md:text-left" path="RightOfWithdrawal.General.Description">
      <template #withdrawalDownload>
        <span
          class="underline cursor-pointer"
          @click="onWithdrawalDownload"
        >
          {{ $t('RightOfWithdrawal.General.LinkWord') }}
        </span>
      </template>
      <template #breakline>
        <br>
      </template>
      <template #br>
        <br>
      </template>
      <template #email>
        <span v-text="$t('Email')" />
      </template>
    </i18n>
  </div>
</template>

<script>
import { downloadWithdrawalForm } from '@/utils/account'
import { convertSrc } from '@/utils/general'
import { mapState } from 'vuex'

export default {
  name: 'RightOfWithdrawalComponent', // name clash
  computed: {
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  methods: {
    onWithdrawalDownload () {
      const url = convertSrc(`/images/frontend/legal/ota-withdrawal-form-${this.locale}.pdf`, true)
      downloadWithdrawalForm()
      window.open(url, '_blank', 'noopener')
    }
  }
}
</script>
